exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#__vconsole{display:none}.vconsole_show{display:block!important}", ""]);

// exports
